/**
 * Utility functions for credit-related operations
 */

/**
 * Checks if the current user's studio is unauthorized to perform operations on a credit
 * @param purchaseStoreId - The store ID where the credit was purchased
 * @param currentUserStoreId - The current user's store ID
 * @returns boolean indicating if the studio is unauthorized
 */
export const isUnauthorizedStudio = (
  purchaseStoreId?: number,
  currentUserStoreId?: string
): boolean => {
  return (
    purchaseStoreId &&
    currentUserStoreId &&
    purchaseStoreId.toString() !== currentUserStoreId
  );
};
